import React from 'react'
import { DocumentationWidget } from '../../widgets/DocumentationWidget'


export const HomePage: React.FC = () => {
  return (
    <DocumentationWidget />
  )
}
